<div class="page-title">
  <mat-icon (click)="navBack()" color="primary">arrow_back</mat-icon>
  <span>{{pageTitle}}</span>
</div>